import { fromCodeData } from './CodeData.js';
import { fromPersonData } from './PersonData.js';
import { asBoolean, optionalEnum, optionalString, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.document.details.DocumentTypeField
 */
export const DocumentTypeField = Object.freeze({
  CLINICAL_DEPARTMENT: 'CLINICAL_DEPARTMENT',
  LETTER_TYPE: 'LETTER_TYPE',
});

/**
 * Mirrors com.medprompt.document.details.DocumentDetails
 *
 * @typedef {object} DocumentDetailsData
 * @property {import('./PersonData.js').PersonData|null} sender
 * @property {import('./PersonData.js').PersonData|null} recipient
 * @property {string|null} documentTypeField
 * @property {import('./CodeData.js').CodeData|null} letterTypeCode
 * @property {import('./CodeData.js').CodeData|null} clinicalDepartment
 * @property {boolean} isHiddenFromPatient
 * @property {string|null} date
 */

/**
 * @param {object} raw
 * @returns {DocumentDetailsData}
 */
export function fromDocumentDetailsData(raw) {
  const source = requireObject(raw, 'DocumentDetails');
  return {
    sender: source.sender == null ? null : fromPersonData(source.sender),
    recipient: source.recipient == null ? null : fromPersonData(source.recipient),
    documentTypeField: optionalEnum(
      source.documentTypeField, DocumentTypeField, 'DocumentDetails', 'documentTypeField'),
    letterTypeCode: source.letterTypeCode == null ? null : fromCodeData(source.letterTypeCode),
    clinicalDepartment: source.clinicalDepartment == null ? null : fromCodeData(source.clinicalDepartment),
    isHiddenFromPatient: asBoolean(source.isHiddenFromPatient),
    date: optionalString(source.date),
  };
}
